import Slider from "components/Slider/Slider";
import MovieList from "components/MovieList/MovieList/MovieList";

export const Homepage = () => {
  return (
    <>
      <Slider />
      <MovieList />
    </>
  );
};
